import { render } from "./PrivacyPolicyView.vue?vue&type=template&id=4e07357a&scoped=true"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js"

import "./PrivacyPolicyView.vue?vue&type=style&index=0&id=4e07357a&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e07357a"]])

export default __exports__